import { render, staticRenderFns } from "./survey-index.vue?vue&type=template&id=75a8c796"
import script from "./survey-index.vue?vue&type=script&lang=js"
export * from "./survey-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports